import React from 'react';

const FlaskIcon = ({ fillColor, width = "55", height = "55", ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 488.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill={fillColor}
      stroke="none"
    >
      <path
        d="M2240 4869 c-554 -46 -1082 -292 -1480 -689 -375 -375 -614 -870
-681 -1405 -18 -143 -15 -445 5 -590 130 -934 772 -1688 1672 -1965 230 -71
403 -95 689 -95 258 0 366 13 589 69 664 168 1237 633 1540 1250 111 227 183
455 223 706 27 176 25 550 -5 725 -47 269 -114 472 -234 709 -305 597 -869
1051 -1511 1215 -271 70 -536 93 -807 70z m-938 -949 c21 -22 29 -37 25 -53
-3 -12 -8 -36 -12 -53 -11 -50 12 -64 103 -64 93 0 106 -7 100 -49 -6 -44 24
-66 110 -80 93 -16 119 -28 131 -62 6 -18 17 -29 28 -29 11 0 52 -20 93 -45
41 -24 82 -45 91 -45 26 0 216 -77 256 -104 49 -33 82 -84 62 -97 -23 -15 -62
-10 -140 16 -97 34 -149 31 -167 -8 -24 -49 21 -598 64 -787 20 -90 72 -245
102 -305 56 -114 225 -330 348 -445 171 -160 427 -288 688 -345 l79 -17 66 65
c83 80 108 97 146 97 68 0 69 -29 5 -107 -28 -33 -37 -50 -29 -58 5 -5 43 -10
82 -10 40 -1 98 -7 129 -15 55 -13 59 -13 88 8 28 21 32 22 59 7 21 -10 60
-15 128 -15 54 0 103 -4 109 -8 30 -20 26 -85 -7 -102 -10 -6 -55 -17 -101
-26 -46 -8 -97 -24 -114 -34 -27 -15 -38 -16 -73 -7 -34 9 -53 8 -99 -5 -134
-38 -185 -48 -327 -65 -269 -31 -657 -15 -920 38 -400 81 -744 293 -990 610
-152 196 -310 480 -388 698 -21 58 -58 188 -83 290 -25 102 -63 230 -85 285
-43 109 -47 152 -20 211 21 47 49 74 109 108 37 21 40 25 23 30 -15 4 -21 13
-21 34 0 38 34 69 83 78 77 15 119 85 83 140 -20 31 -15 42 47 90 64 50 72 83
29 114 -59 42 -65 119 -10 141 47 18 88 11 120 -20z"
      />
      <path
        d="M1198 3913 c-8 -10 -18 -26 -22 -37 -5 -14 -2 -17 10 -12 8 3 36 6
60 6 48 0 57 15 26 43 -24 22 -55 22 -74 0z"
      />
      <path
        d="M1355 3700 c-4 -6 6 -10 24 -10 16 0 33 5 36 10 4 6 -6 10 -24 10
-16 0 -33 -4 -36 -10z"
      />
      <path
        d="M1380 3604 c0 -36 57 -96 89 -92 22 3 26 7 23 32 -3 23 -1 28 12 23
9 -4 16 -4 16 -2 0 10 -49 36 -93 49 -47 14 -47 14 -47 -10z"
      />
      <path
        d="M1283 3543 c-29 -9 -53 -20 -53 -25 0 -5 9 -4 19 2 11 5 48 10 82 10
53 0 60 2 49 15 -15 18 -30 18 -97 -2z"
      />
      <path
        d="M1545 3504 c-27 -8 -120 -33 -205 -55 -85 -22 -158 -43 -163 -48 -5
-5 22 0 59 10 75 21 174 25 205 9 16 -9 19 -7 19 10 0 31 25 24 54 -15 32 -42
63 -45 76 -9 6 14 8 30 4 35 -9 15 8 10 28 -8 21 -19 24 -6 4 20 -7 9 -11 28
-8 42 5 29 -1 30 -73 9z"
      />
      <path
        d="M1788 3403 c-15 -4 -15 -6 3 -24 37 -37 6 -76 -36 -45 -17 12 -18 17
-7 40 l12 26 -43 -6 c-46 -7 -184 -42 -381 -98 -71 -20 -139 -36 -150 -36 -12
0 -27 -4 -35 -9 -11 -7 -8 -13 13 -26 19 -13 24 -21 16 -29 -7 -7 -4 -15 12
-28 18 -13 20 -20 11 -29 -28 -28 -133 21 -133 63 0 19 -4 20 -42 14 -58 -9
-120 -46 -136 -80 -12 -24 -12 -34 3 -72 24 -64 35 -63 35 1 0 31 5 65 11 76
12 24 52 41 74 32 14 -5 13 -8 -5 -20 -27 -19 -25 -34 9 -67 38 -36 94 -42 99
-10 2 17 12 23 49 28 47 6 67 1 58 -15 -15 -23 48 -5 148 43 98 46 120 52 203
59 51 4 110 11 131 14 80 14 229 58 261 77 40 24 66 71 58 104 -6 24 -8 24
-114 23 -59 -1 -115 -3 -124 -6z m97 -38 c-11 -8 -26 -19 -33 -26 -21 -18 -27
-1 -7 21 10 11 28 20 39 20 21 -1 21 -1 1 -15z m-290 -45 c19 -7 19 -8 -6 -18
-14 -5 -37 -8 -52 -5 -14 3 -40 0 -57 -5 -16 -6 -30 -7 -30 -2 0 13 15 20 62
29 55 11 59 11 83 1z m-211 -66 c9 -3 16 -13 16 -21 0 -21 -54 -13 -58 10 -4
18 13 22 42 11z m-40 -55 c45 -35 26 -69 -20 -34 -10 8 -27 15 -36 15 -21 0
-23 11 -6 28 17 17 32 15 62 -9z"
      />
      <path
        d="M1045 3360 c-22 -11 -29 -17 -15 -14 29 8 80 33 65 33 -5 0 -28 -8
-50 -19z"
      />
      <path
        d="M2195 3311 c-3 -5 11 -18 30 -30 26 -15 35 -17 35 -7 0 23 -54 54
-65 37z"
      />
      <path
        d="M1877 3193 c-4 -3 -31 -10 -60 -14 -28 -3 -72 -12 -97 -19 l-45 -12
24 -19 c33 -27 23 -31 -38 -17 -49 11 -52 10 -67 -10 -11 -15 -26 -22 -50 -22
-24 0 -34 -5 -34 -15 0 -26 -60 -55 -113 -55 -60 0 -68 -16 -38 -76 11 -25 21
-50 21 -58 0 -20 -34 -46 -61 -46 -30 0 -69 -26 -69 -46 0 -8 -7 -14 -15 -14
-17 0 -20 -32 -5 -61 7 -12 21 -19 41 -19 42 0 88 -26 99 -56 12 -31 13 -131
2 -138 -11 -7 -27 5 -41 31 -16 31 -14 60 7 72 16 9 15 12 -11 38 l-27 28 -37
-38 -38 -37 39 -31 c32 -27 37 -36 32 -60 -4 -21 -1 -29 13 -34 24 -7 47 -42
58 -85 12 -47 34 -58 66 -33 l25 19 -49 43 c-52 44 -59 68 -19 63 22 -4 22 -1
16 38 -4 27 -2 47 5 56 23 27 30 14 24 -40 -9 -70 5 -79 52 -35 l34 34 30 -35
c56 -68 49 -113 -16 -93 -19 6 -35 9 -35 6 0 -3 23 -26 50 -52 41 -39 50 -53
50 -82 0 -46 23 -79 51 -72 14 4 25 0 31 -11 11 -20 28 -12 28 15 0 23 3 23
40 4 18 -9 34 -30 45 -60 10 -25 22 -45 26 -45 14 0 10 21 -11 68 -10 23 -17
42 -15 42 11 0 86 -88 96 -114 11 -26 10 -31 -10 -47 -13 -11 -33 -19 -45 -19
-18 -1 -15 -7 23 -40 24 -22 54 -40 67 -40 46 0 115 -86 100 -125 -9 -23 -51
-18 -109 14 -28 16 -63 32 -77 35 l-25 7 26 -21 c14 -12 84 -47 155 -79 169
-75 235 -115 312 -194 63 -63 63 -64 38 -71 -29 -7 -103 7 -119 23 -7 7 -6 15
2 24 9 12 5 16 -25 21 -42 8 -48 5 -39 -23 10 -31 56 -51 150 -63 l85 -12 -15
-23 c-10 -14 -11 -23 -5 -23 6 0 9 -8 6 -18 -8 -23 34 -45 68 -36 19 4 30 -2
52 -30 34 -42 53 -45 90 -11 34 32 41 32 20 0 l-17 -26 40 21 c61 31 129 26
230 -15 130 -53 236 -78 277 -65 19 7 32 15 29 20 -3 4 -37 16 -77 25 -40 10
-81 27 -93 39 -14 14 -35 21 -61 22 -52 2 -98 26 -150 76 -29 28 -64 47 -122
67 -45 16 -104 43 -132 61 -63 40 -133 118 -127 141 3 11 -9 30 -30 51 -19 18
-64 76 -99 128 -79 118 -124 170 -131 152 -3 -9 -12 -3 -24 17 -10 17 -30 37
-44 43 -30 14 -32 29 -5 53 12 11 17 22 11 29 -9 12 -63 200 -82 289 -7 31
-15 57 -19 57 -9 0 -36 -31 -43 -50 -3 -9 -5 -5 -6 10 0 36 14 65 30 65 19 0
24 44 6 51 -11 4 -13 13 -6 42 8 37 3 82 -10 82 -3 0 -4 44 -3 98 3 81 1 102
-13 115 -13 14 -14 23 -6 54 14 48 14 144 1 177 -9 25 -46 36 -63 19z m19
-180 c-6 -59 -4 -58 24 12 8 18 9 18 9 -5 1 -36 -35 -110 -53 -110 -20 0 -30
41 -21 87 16 89 50 102 41 16z m-344 -133 c6 0 7 -7 4 -16 -4 -9 -1 -23 5 -30
16 -20 -1 -17 -39 6 -19 11 -32 26 -29 33 2 7 0 23 -5 36 l-8 23 31 -26 c17
-14 35 -26 41 -26z m28 35 c0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15
10 15 6 0 10 -7 10 -15z m-31 -116 c24 -11 42 -22 38 -25 -3 -3 -27 4 -52 15
-26 12 -54 21 -61 21 -8 0 -14 5 -14 11 0 12 24 6 89 -22z m-71 -9 c48 -25 88
-57 81 -64 -10 -11 -104 26 -121 48 -34 41 -18 47 40 16z m370 -5 c-3 -3 -9 2
-12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m-384 -64 c19 -21 19 -21 -2 -21
-22 0 -92 55 -92 71 0 13 71 -25 94 -50z m-34 -26 c16 -20 8 -59 -13 -63 -12
-2 -31 11 -52 35 -41 45 -44 60 -10 37 27 -18 31 -13 15 16 -9 17 -8 18 19 4
16 -8 34 -21 41 -29z m86 -52 c-7 -7 -26 7 -26 19 0 6 6 6 15 -2 9 -7 13 -15
11 -17z m314 -24 c0 -10 7 -19 15 -19 11 0 15 -11 15 -38 0 -21 4 -42 9 -47
10 -12 -4 -55 -18 -55 -22 0 -51 68 -51 122 0 30 3 58 6 61 11 10 24 -3 24
-24z m87 -1 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m28 -15 c-9
-37 -18 -20 -9 19 4 18 9 27 11 20 3 -7 2 -24 -2 -39z m-330 -83 c5 0 -10 41
-25 71 -8 15 -7 19 4 19 8 0 35 -25 60 -55 40 -49 43 -57 33 -79 -7 -13 -15
-22 -20 -19 -4 2 -14 -1 -22 -7 -11 -10 -18 -10 -29 -1 -19 16 -53 98 -61 146
l-6 40 31 -57 c17 -32 32 -58 35 -58z m-135 44 c0 -8 -4 -12 -10 -9 -5 3 -10
10 -10 16 0 5 5 9 10 9 6 0 10 -7 10 -16z m74 -46 c-9 -14 -24 2 -24 25 1 21
1 21 15 3 8 -10 12 -23 9 -28z m126 -248 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10
10 0 6 5 10 10 10 6 0 10 -4 10 -10z m368 -76 l-4 -29 -12 28 c-13 31 -7 56
10 39 5 -5 8 -22 6 -38z m52 -139 c0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8
5 15 10 15 6 0 10 -7 10 -15z m108 -141 c-10 -10 -28 6 -28 24 0 15 1 15 17
-1 9 -9 14 -19 11 -23z m89 -117 c31 -46 40 -71 22 -65 -17 6 -59 66 -59 84 0
23 14 16 37 -19z"
      />
      <path d="M985 3030 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z" />
      <path
        d="M1237 2957 c43 -16 55 -31 21 -25 -34 6 -37 -9 -4 -18 31 -7 68 12
64 34 -2 13 -16 17 -58 19 -53 2 -54 2 -23 -10z"
      />
      <path
        d="M1112 2918 c7 -19 35 -21 41 -3 5 11 0 15 -19 15 -16 0 -24 -5 -22
-12z"
      />
      <path d="M1188 2883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
      <path
        d="M1150 2859 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
      />
      <path
        d="M1114 2785 c22 -17 46 -20 46 -6 0 10 -25 21 -48 21 -15 -1 -14 -3 2
-15z"
      />
      <path d="M1007 2744 c-8 -14 8 -37 22 -33 8 3 8 10 -2 23 -8 11 -17 15 -20 10z" />
      <path
        d="M1105 2740 c-3 -6 4 -14 17 -19 27 -10 33 -7 25 14 -7 17 -33 20 -42
5z"
      />
      <path d="M1100 2696 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z" />
      <path
        d="M1055 2615 c2 -16 7 -41 11 -55 5 -22 4 -22 -14 6 -30 46 -44 52 -30
12 6 -18 14 -38 19 -43 4 -6 24 -48 43 -94 34 -82 83 -167 91 -159 4 4 -31 99
-61 166 -9 21 -10 31 -3 26 18 -11 3 40 -32 111 -21 43 -28 52 -24 30z"
      />
      <path
        d="M1260 2440 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0
-15 -4 -15 -10z"
      />
      <path
        d="M1430 2430 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M1515 2334 c26 -64 10 -76 -61 -45 -74 33 -89 26 -62 -30 9 -19 40
-39 112 -72 137 -64 153 -62 92 9 -21 25 -40 61 -48 94 -7 29 -19 56 -27 58
-10 4 -12 0 -6 -14z"
      />
      <path
        d="M1116 2300 c13 -52 87 -187 166 -304 44 -66 85 -122 89 -124 5 -2 9
-11 9 -19 0 -9 25 -53 56 -99 68 -103 259 -283 319 -301 21 -7 41 -10 44 -8
14 14 -24 56 -73 80 -50 24 -106 74 -106 93 0 4 -13 15 -29 24 -17 9 -39 35
-51 57 -12 25 -27 41 -38 41 -29 0 -57 33 -80 96 -13 35 -36 74 -57 94 -19 19
-35 39 -35 44 0 6 -25 43 -56 81 -31 39 -74 106 -94 150 -21 44 -45 89 -54
100 -17 20 -17 20 -10 -5z"
      />
      <path
        d="M1380 2105 c7 -8 17 -15 22 -15 6 0 5 7 -2 15 -7 8 -17 15 -22 15 -6
0 -5 -7 2 -15z"
      />
      <path
        d="M1755 2110 c-4 -6 -4 -10 -1 -10 2 0 11 -3 20 -6 9 -3 16 -2 16 4 0
14 -28 23 -35 12z"
      />
      <path
        d="M1584 2084 c4 -12 2 -15 -9 -10 -9 3 -15 0 -15 -9 0 -8 -8 -15 -17
-15 -14 0 -13 -4 6 -24 12 -13 21 -28 19 -34 -2 -6 13 -25 32 -42 33 -30 29
-32 -19 -12 -9 3 -12 1 -8 -5 7 -12 190 -113 203 -113 4 0 -1 9 -10 19 -10 11
-15 24 -12 29 3 5 -6 20 -19 32 -14 13 -25 29 -25 36 0 7 -12 22 -27 34 -19
14 -24 23 -15 27 10 4 10 8 1 19 -9 11 -6 16 15 25 14 7 26 15 26 19 0 7 -104
40 -124 40 -5 0 -5 -7 -2 -16z"
      />
      <path
        d="M1450 2055 c0 -2 10 -10 23 -16 20 -11 21 -11 8 4 -13 16 -31 23 -31
12z"
      />
      <path
        d="M1670 1806 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z"
      />
      <path
        d="M1830 1790 c0 -5 1 -10 3 -10 1 0 17 -4 35 -9 40 -12 41 -6 2 14 -34
18 -40 18 -40 5z"
      />
      <path
        d="M1675 1750 c-10 -16 22 -44 73 -64 52 -20 102 -21 128 -2 19 14 19
15 -1 22 -11 4 -40 15 -65 24 -65 25 -126 34 -135 20z"
      />
      <path
        d="M1920 1710 c19 -16 49 -32 67 -36 39 -7 68 0 38 10 -11 4 -41 18 -66
32 -63 33 -82 30 -39 -6z"
      />
      <path
        d="M1995 1724 c24 -18 90 -36 118 -32 15 2 0 11 -44 26 -77 26 -103 28
-74 6z"
      />
      <path
        d="M2470 1670 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path
        d="M2005 1632 c6 -6 24 -14 40 -18 21 -4 27 -3 20 4 -5 6 -23 14 -40 18
-21 4 -27 3 -20 -4z"
      />
      <path d="M1990 1561 c0 -10 80 -44 87 -37 5 4 -69 46 -82 46 -3 0 -5 -4 -5 -9z" />
      <path
        d="M2085 1560 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"
      />
      <path d="M1938 1543 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
      <path
        d="M1910 1460 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"
      />
      <path
        d="M2065 1460 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"
      />
      <path
        d="M2135 1440 c3 -5 13 -10 21 -10 8 0 14 5 14 10 0 6 -9 10 -21 10 -11
0 -17 -4 -14 -10z"
      />
      <path
        d="M2320 1420 c0 -5 6 -10 14 -10 8 0 18 5 21 10 3 6 -3 10 -14 10 -12
0 -21 -4 -21 -10z"
      />
      <path
        d="M3350 1409 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
      />
      <path
        d="M1937 1349 c6 -6 53 -33 104 -60 52 -26 87 -48 79 -49 -8 0 -60 23
-114 50 -108 54 -140 61 -52 11 62 -35 195 -91 301 -128 96 -33 429 -83 606
-90 149 -6 268 2 253 17 -9 9 -211 18 -384 19 -166 0 -285 25 -470 98 -91 36
-197 83 -237 104 -71 38 -109 51 -86 28z"
      />
      <path
        d="M2050 1350 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"
      />
      <path
        d="M2728 1291 c-33 -30 -35 -51 -2 -33 14 8 21 6 30 -6 10 -14 14 -14
28 -2 21 17 17 64 -6 68 -9 2 -31 -10 -50 -27z"
      />
      <path
        d="M2843 1288 c-22 -10 -32 -38 -15 -38 13 0 52 30 52 41 0 11 -9 11
-37 -3z"
      />
      <path
        d="M3274 1286 c-16 -12 -16 -15 -4 -19 25 -9 234 -17 258 -10 41 10 23
20 -60 31 -111 16 -170 15 -194 -2z"
      />
      <path
        d="M3610 1270 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path d="M3845 1270 c-7 -12 88 -12 125 0 18 6 4 8 -47 9 -39 1 -75 -3 -78 -9z" />
      <path
        d="M2200 1260 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
      />
      <path d="M2920 1250 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z" />
      <path d="M2845 1236 c-11 -8 -14 -15 -8 -19 6 -4 16 0 23 8 17 21 8 28 -15 11z" />
      <path
        d="M2322 1216 c33 -20 132 -46 172 -46 51 0 16 18 -64 34 -41 8 -88 17
-105 21 l-30 6 27 -15z"
      />
      <path
        d="M2940 1215 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"
      />
      <path
        d="M3029 1211 c-19 -16 -20 -20 -8 -21 17 0 45 27 37 35 -3 3 -16 -3
-29 -14z"
      />
      <path
        d="M3175 1100 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z"
      />
    </g>
  </svg>
);

export default FlaskIcon;